import { curry } from 'ramda'

const doesParentExistRule = {
  name: 'doesParentExistRule',
  rule: curry(({ components }, __, { parent }) => Boolean(components[parent])),
}

export const rules = {
  defaults: [doesParentExistRule],
}
